/* Droo — scripts du thème */
(function () {
  'use strict';

  var cfg = window.droo || { routes: {}, strings: {} };
  var root = (cfg.routes.root_url || '/').replace(/\/?$/, '/');
  var mqMobile = window.matchMedia('(max-width: 809px)');

  function formatMoney(cents) {
    var value = cents / 100;
    var num = (cents % 100 === 0) ? String(Math.round(value)) : value.toFixed(2).replace('.', ',');
    return num + ' ' + (cfg.currencySymbol || '€');
  }
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function store(key, val) { try { if (val === undefined) return window.localStorage.getItem(key); window.localStorage.setItem(key, val); } catch (e) { return null; } }

  /* ---------- Filtres Tout / Régulier / Mini / Kit ---------- */
  function applyFilter(tabsEl, filter) {
    tabsEl.querySelectorAll('[data-filter]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-filter') === filter); });
    var list = tabsEl.parentElement.querySelector('[data-filter-list]');
    if (!list) return;
    var limit = list.hasAttribute('data-loop') ? 999 : 4;
    list.querySelectorAll('[data-range]').forEach(function (card) {
      var show = filter === 'all' ? parseInt(card.getAttribute('data-index'), 10) <= limit : card.getAttribute('data-range') === filter;
      card.hidden = !show;
    });
    list.scrollLeft = 0;
    var active = tabsEl.querySelector('[data-filter="' + filter + '"]');
    var scope = tabsEl.parentElement;
    if (active && active.getAttribute('data-url')) scope.querySelectorAll('[data-more]').forEach(function (a) { a.setAttribute('href', active.getAttribute('data-url')); });
  }
  /* Menu produits : défilement horizontal en boucle */
  document.querySelectorAll('[data-loop]').forEach(function (track) {
    var slider = track.closest('.panel__slider');
    function step() { var c = track.querySelector('.pcard:not([hidden])'); return c ? c.getBoundingClientRect().width : track.clientWidth / 3; }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
      else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (!slider) return;
    slider.querySelector('[data-track-prev]').addEventListener('click', function () { go(-1); });
    slider.querySelector('[data-track-next]').addEventListener('click', function () { go(1); });
    var down = false, x0 = 0, s0 = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft; track.classList.add('is-drag'); });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = s0 - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; track.classList.remove('is-drag'); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });
  document.querySelectorAll('.panel__tabs').forEach(function (tabs) {
    applyFilter(tabs, 'all');
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]');
      if (b) applyFilter(tabs, b.getAttribute('data-filter'));
    });
  });

  /* ---------- En-tête : méga-menus ---------- */
  var header = document.querySelector('[data-header]');
  var backdrop = document.querySelector('[data-panel-backdrop]');
  function closePanels() {
    if (!header) return;
    header.classList.remove('is-open');
    header.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.remove('is-active'); });
    header.querySelectorAll('[data-panel-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (backdrop) backdrop.classList.remove('is-visible');
  }
  function openPanel(id) {
    var panel = header.querySelector('[data-panel="' + id + '"]');
    if (!panel) return;
    header.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-active', p === panel); });
    header.querySelectorAll('[data-panel-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-panel-toggle') === id ? 'true' : 'false'); });
    header.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-visible');
  }
  function toggleMobile(force) {
    var open = typeof force === 'boolean' ? force : !header.classList.contains('is-mobile-open');
    header.classList.toggle('is-mobile-open', open);
    document.body.classList.toggle('no-scroll', open);
    var btn = header.querySelector('[data-mobile-toggle]');
    if (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('[data-label-open]').hidden = open;
      btn.querySelector('[data-label-close]').hidden = !open;
    }
  }
  if (header) {
    header.querySelectorAll('[data-panel-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-expanded') === 'true') closePanels(); else openPanel(btn.getAttribute('data-panel-toggle'));
      });
    });
    var mt = header.querySelector('[data-mobile-toggle]');
    if (mt) mt.addEventListener('click', function () { toggleMobile(); });
    if (backdrop) backdrop.addEventListener('click', closePanels);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanels(); toggleMobile(false); } });
    document.addEventListener('click', function (e) {
      if (header.classList.contains('is-open') && !e.target.closest('[data-header]')) closePanels();
    });
    mqMobile.addEventListener && mqMobile.addEventListener('change', function () { closePanels(); toggleMobile(false); });
    document.addEventListener('shopify:block:select', function (e) {
      var t = e.target.closest && e.target.closest('[data-panel-toggle]');
      if (t) openPanel(t.getAttribute('data-panel-toggle'));
    });
  }

  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { store('droo-country-chosen', '1'); el.form.submit(); });
  });

  /* ---------- Garder la langue (/fr) sur tous les liens internes ---------- */
  (function () {
    if (root === '/') return;
    var skip = /^\/(cdn|apps|tools|services|checkouts?|s\/|\/)/;
    function fix(scope) {
      (scope || document).querySelectorAll('a[href^="/"]').forEach(function (a) {
        var h = a.getAttribute('href');
        if (!h || h.indexOf(root) === 0 || h + '/' === root || skip.test(h)) return;
        a.setAttribute('href', root.replace(/\/$/, '') + h);
      });
      (scope || document).querySelectorAll('form[action^="/"]').forEach(function (f) {
        var h = f.getAttribute('action');
        if (h.indexOf(root) === 0 || skip.test(h) || /^\/localization/.test(h)) return;
        f.setAttribute('action', root.replace(/\/$/, '') + h);
      });
    }
    fix();
    new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) fix(n); }); }); })
      .observe(document.body, { childList: true, subtree: true });
  })();

  /* ---------- Marché automatique selon la géolocalisation ---------- */
  (function () {
    var select = document.querySelector('select[name="country_code"]');
    if (!select || store('droo-country-chosen') === '1' || (window.Shopify && window.Shopify.designMode)) return;
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        store('droo-country-chosen', '1');
        if (!detected || detected === select.value) return;
        var ok = Array.prototype.some.call(select.options, function (o) { return o.value === detected; });
        if (!ok) return;
        select.value = detected;
        select.form.submit();
      })
      .catch(function () {});
  })();

  /* ---------- Panier (tiroir) ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var strings = {};
  try { strings = JSON.parse(document.querySelector('[data-cart-strings]').textContent); } catch (e) {}

  function openDrawer() {
    if (!drawer) { window.location.href = cfg.routes.cart_url; return; }
    closePanels(); if (header) toggleMobile(false);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
    var list = drawer.querySelector('[data-cart-items]');
    var title = drawer.querySelector('[data-cart-title]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var total = drawer.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    var disc = drawer.querySelector('[data-cart-discounts]');
    if (disc) disc.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<div class="drawer__disc"><span>' + escapeHtml(d.title) + '</span><span class="t-num">-' + formatMoney(d.total_allocated_amount) + '</span></div>';
    }).join('');
    if (title) title.textContent = cart.item_count ? (strings.title || 'Votre panier') + ' (' + cart.item_count + ')' : (strings.empty || '');
    if (foot) foot.hidden = !cart.item_count;
    list.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="line__meta">' + escapeHtml(item.variant_title) + '</p>' : '';
      return '<div class="line" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="line__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="line__info"><div class="line__top"><a href="' + item.url + '" class="line__name">' + escapeHtml(item.product_title) + '</a>' +
        '<span class="line__price">' + formatMoney(item.final_line_price) + '</span></div>' + variant +
        '<div class="line__bottom"><div class="qty"><button type="button" data-qty="-1" aria-label="-">−</button><span>' + item.quantity + '</span><button type="button" data-qty="1" aria-label="+">+</button></div>' +
        '<button type="button" class="line__remove" data-remove>' + escapeHtml(strings.remove || '×') + '</button></div></div></div>';
    }).join('');

    var ship = drawer.querySelector('[data-free-shipping]');
    if (ship) {
      var goal = parseInt(ship.getAttribute('data-free-shipping'), 10) || 0;
      var remaining = Math.max(goal - cart.total_price, 0);
      var pct = goal ? Math.min(cart.total_price / goal * 100, 100) : 0;
      ship.querySelector('[data-shipping-bar]').style.width = pct + '%';
      ship.querySelector('[data-shipping-text]').textContent = remaining === 0
        ? (strings.freeShippingReached || '')
        : (strings.freeShippingRemaining || '').replace('[amount]', formatMoney(remaining));
    }
  }
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }
  function changeLine(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var line = e.target.closest('.line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var q = parseInt(line.querySelector('.qty span').textContent, 10) || 0;
      if (e.target.closest('[data-remove]')) { changeLine(key, 0); return; }
      var step = e.target.closest('[data-qty]');
      if (step) changeLine(key, Math.max(0, q + parseInt(step.getAttribute('data-qty'), 10)));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    fetchCart();
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-open]');
    if (!link || !drawer) return;
    e.preventDefault();
    openDrawer();
    fetchCart();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var buyNow = btn && btn.hasAttribute('data-buy-now');
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || cfg.strings.error);
        if (buyNow) { window.location.href = root + 'checkout'; return; }
        return fetchCart().then(openDrawer);
      })
      .catch(function (err) { window.alert(err.message || cfg.strings.error); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Accordéons génériques ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-acc-toggle]');
    if (!head) return;
    var acc = head.closest('[data-acc]');
    var open = !acc.classList.contains('is-open');
    acc.classList.toggle('is-open', open);
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Page produit ---------- */
  document.querySelectorAll('[data-product]').forEach(function (productEl) {
    var product = null;
    try { product = JSON.parse(productEl.querySelector('[data-product-json]').textContent); } catch (e) {}
    var slides = productEl.querySelectorAll('.gallery__slide');
    var thumbs = productEl.querySelectorAll('.gallery__thumb');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === current); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === current); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var lb = productEl.querySelector('[data-lightbox]');
    if (lb) {
      var zooms = Array.prototype.filter.call(slides, function (s) { return s.hasAttribute('data-zoom'); });
      var lbImg = lb.querySelector('[data-lightbox-img]');
      var lbIndex = 0;
      var lbShow = function (i) { if (!zooms.length) return; lbIndex = (i + zooms.length) % zooms.length; lbImg.src = zooms[lbIndex].getAttribute('data-zoom'); };
      var lbOpen = function (i) { lbShow(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); };
      var lbClose = function () { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); };
      zooms.forEach(function (s, i) { s.addEventListener('click', function () { lbOpen(i); }); });
      lb.querySelector('[data-lightbox-close]').addEventListener('click', lbClose);
      lb.querySelector('[data-lightbox-prev]').addEventListener('click', function () { lbShow(lbIndex - 1); });
      lb.querySelector('[data-lightbox-next]').addEventListener('click', function () { lbShow(lbIndex + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1); else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });
    }
    var prev = productEl.querySelector('.gallery__arrow--prev');
    var next = productEl.querySelector('.gallery__arrow--next');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var gal = productEl.querySelector('.gallery');
    if (gal) {
      var x0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    if (product && product.variants.length > 1) {
      var idInput = productEl.querySelector('input[name="id"]');
      var priceEl = productEl.querySelector('[data-price]');
      var btn = productEl.querySelector('[data-add-button]');
      productEl.querySelectorAll('.variant-picker input').forEach(function (input) {
        input.addEventListener('change', function () {
          var selected = Array.prototype.map.call(productEl.querySelectorAll('.variant-picker'), function (fs) {
            var checked = fs.querySelector('input:checked');
            return checked ? checked.value : null;
          });
          var variant = product.variants.find(function (v) { return v.options.every(function (opt, i) { return opt === selected[i]; }); });
          if (!variant) return;
          idInput.value = variant.id;
          if (priceEl) priceEl.innerHTML = formatMoney(variant.price) + (variant.compare_at_price > variant.price ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
          if (btn) { btn.disabled = !variant.available; btn.textContent = variant.available ? cfg.strings.addToCart : cfg.strings.soldOut; }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
          if (variant.featured_media) {
            slides.forEach(function (s, j) { if (s.getAttribute('data-media-id') == variant.featured_media.id) show(j); });
          }
        });
      });
    }

    var sticky = document.querySelector('[data-sticky-atc]');
    var buttons = productEl.querySelector('.pinfo__buttons');
    if (sticky && buttons && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }).observe(buttons);
      sticky.querySelector('button').addEventListener('click', function () {
        var mainForm = productEl.querySelector('form[data-add-to-cart]');
        if (mainForm) mainForm.requestSubmit(mainForm.querySelector('[data-add-button]'));
      });
    }
  });

  /* ---------- Ingrédients (accordéon + image) ---------- */
  document.querySelectorAll('[data-ingredients]').forEach(function (wrap) {
    var items = wrap.querySelectorAll('.ingr__item');
    var images = wrap.querySelectorAll('.ingr__media img');
    items.forEach(function (item, i) {
      item.querySelector('.ingr__head').addEventListener('click', function () {
        items.forEach(function (it) { it.classList.toggle('is-open', it === item); it.querySelector('.ingr__head').setAttribute('aria-expanded', it === item ? 'true' : 'false'); });
        images.forEach(function (img, j) { img.classList.toggle('is-active', j === i); });
      });
    });
  });

  /* ---------- Témoignages : « Voir plus » (mobile) ---------- */
  document.querySelectorAll('[data-testi-more]').forEach(function (btn) {
    btn.addEventListener('click', function () { btn.closest('.testi').classList.remove('is-collapsed'); });
  });

  /* ---------- Klaviyo : inscription newsletter / pop-up ---------- */
  var S2 = cfg.strings2 || {};
  function klaviyoSubscribe(email, source) {
    var k = cfg.klaviyo || {};
    if (!k.key || !k.list) return Promise.reject(new Error('config'));
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source || 'Shopify', profile: { data: { type: 'profile', attributes: { email: email, properties: { language: document.documentElement.lang } } } } }, relationships: { list: { data: { type: 'list', id: k.list } } } } })
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('http ' + r.status); return true; });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-klaviyo-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[type=email]');
    var email = (input.value || '').trim();
    var scope = form.closest('.popup, .ibanner__content') || form.parentNode;
    var err = scope.querySelector('[data-klaviyo-error]');
    if (err) err.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (err) { err.textContent = S2.invalidEmail || 'Invalid email'; err.hidden = false; } return; }
    var btn = form.querySelector('button'); if (btn) btn.disabled = true;
    klaviyoSubscribe(email, form.getAttribute('data-source')).then(function () {
      form.dispatchEvent(new CustomEvent('klaviyo:success', { bubbles: true }));
      var ok = scope.querySelector('[data-klaviyo-success]');
      if (ok) { form.hidden = true; ok.hidden = false; }
    }).catch(function () {
      if (err) { err.textContent = S2.error || 'Error'; err.hidden = false; }
    }).finally(function () { if (btn) btn.disabled = false; });
  });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy-code]');
    if (!c) return;
    var code = c.getAttribute('data-copy-code');
    try { navigator.clipboard.writeText(code); } catch (x) {}
    var old = c.textContent; c.textContent = S2.copied || 'Copied!';
    setTimeout(function () { c.textContent = old; }, 1500);
  });

  /* ---------- Popup newsletter ---------- */
  document.querySelectorAll('[data-popup]').forEach(function (popup) {
    var key = 'droo-popup-' + popup.getAttribute('data-popup');
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    var hideDays = parseInt(popup.getAttribute('data-hide-days'), 10) || 0;
    var autoClose = parseInt(popup.getAttribute('data-auto-close'), 10) || 0;
    var isDesignMode = window.Shopify && window.Shopify.designMode;
    var state = null; try { state = JSON.parse(store(key) || 'null'); } catch (x) {}
    var hidden = state && (state.subscribed || (state.closedAt && (hideDays === 0 || Date.now() - state.closedAt < hideDays * 864e5)));
    function open() { popup.classList.add('is-open'); }
    function close() {
      popup.classList.remove('is-open');
      if (!(state && state.subscribed)) { state = { closedAt: Date.now() }; store(key, JSON.stringify(state)); }
    }
    if (!hidden && !isDesignMode) setTimeout(open, delay * 1000);
    popup.addEventListener('click', function (e) { if (e.target === popup || e.target.closest('[data-popup-close]')) close(); });
    popup.addEventListener('klaviyo:success', function () {
      state = { subscribed: true }; store(key, JSON.stringify(state));
      popup.querySelector('[data-popup-step="form"]').hidden = true;
      popup.querySelector('[data-popup-step="success"]').hidden = false;
      if (autoClose) setTimeout(function () { popup.classList.remove('is-open'); }, autoClose * 1000);
    });
    document.addEventListener('shopify:section:select', function (e) { if (popup.closest('[id^="shopify-section"]') === e.target) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (popup.closest('[id^="shopify-section"]') === e.target) popup.classList.remove('is-open'); });
  });

  /* Inscrit depuis n'importe quel formulaire : la popup -10 % ne revient plus */
  document.addEventListener('klaviyo:success', function () {
    document.querySelectorAll('[data-popup]').forEach(function (p) { store('droo-popup-' + p.getAttribute('data-popup'), JSON.stringify({ subscribed: true })); });
  });

  /* ---------- Pages légales : sommaire automatique ---------- */
  document.querySelectorAll('[data-toc]').forEach(function (toc) {
    var content = document.querySelector(toc.getAttribute('data-toc'));
    if (!content) return;
    var heads = content.querySelectorAll('h2, h3');
    if (!heads.length) { toc.hidden = true; return; }
    heads.forEach(function (h, i) {
      if (!h.textContent.trim()) return;
      if (!h.id) h.id = 'section-' + (i + 1);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      toc.appendChild(a);
    });
  });

  /* ---------- Apparition au défilement ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- Fond dégradé animé (shader identique au site Framer) ---------- */
  var FRAG = '#version 300 es\nprecision highp float;\nuniform float u_time;uniform float u_pixelRatio;uniform vec2 u_resolution;uniform float u_scale;uniform float u_rotation;uniform vec4 u_color1;uniform vec4 u_color2;uniform vec4 u_color3;uniform float u_proportion;uniform float u_softness;uniform float u_shape;uniform float u_shapeScale;uniform float u_distortion;uniform float u_swirl;uniform float u_swirlIterations;\nout vec4 fragColor;\n#define TWO_PI 6.28318530718\n#define PI 3.14159265358979323846\n' +
    'vec2 rotate(vec2 uv, float th){return mat2(cos(th),sin(th),-sin(th),cos(th))*uv;}\n' +
    'float random(vec2 st){return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123);}\n' +
    'float noise(vec2 st){vec2 i=floor(st);vec2 f=fract(st);float a=random(i);float b=random(i+vec2(1.0,0.0));float c=random(i+vec2(0.0,1.0));float d=random(i+vec2(1.0,1.0));vec2 u=f*f*(3.0-2.0*f);float x1=mix(a,b,u.x);float x2=mix(c,d,u.x);return mix(x1,x2,u.y);}\n' +
    'vec4 blend_colors(vec4 c1,vec4 c2,vec4 c3,float mixer,float edgesWidth,float edge_blur){vec3 color1=c1.rgb*c1.a;vec3 color2=c2.rgb*c2.a;vec3 color3=c3.rgb*c3.a;float r1=smoothstep(.0+.35*edgesWidth,.7-.35*edgesWidth+.5*edge_blur,mixer);float r2=smoothstep(.3+.35*edgesWidth,1.-.35*edgesWidth+edge_blur,mixer);vec3 blended_color_2=mix(color1,color2,r1);float blended_opacity_2=mix(c1.a,c2.a,r1);vec3 c=mix(blended_color_2,color3,r2);float o=mix(blended_opacity_2,c3.a,r2);return vec4(c,o);}\n' +
    'void main(){vec2 uv=gl_FragCoord.xy/u_resolution.xy;float t=.5*u_time;float noise_scale=.0005+.006*u_scale;uv-=.5;uv*=(noise_scale*u_resolution);uv=rotate(uv,u_rotation*.5*PI);uv/=u_pixelRatio;uv+=.5;float n1=noise(uv*1.+t);float n2=noise(uv*2.-t);float angle=n1*TWO_PI;uv.x+=4.*u_distortion*n2*cos(angle);uv.y+=4.*u_distortion*n2*sin(angle);float iterations_number=ceil(clamp(u_swirlIterations,1.,30.));for(float i=1.;i<=iterations_number;i++){uv.x+=clamp(u_swirl,0.,2.)/i*cos(t+i*1.5*uv.y);uv.y+=clamp(u_swirl,0.,2.)/i*cos(t+i*1.*uv.x);}float proportion=clamp(u_proportion,0.,1.);float shape=0.;float mixer=0.;vec2 checks_shape_uv=uv*(.5+3.5*u_shapeScale);shape=.5+.5*sin(checks_shape_uv.x)*cos(checks_shape_uv.y);mixer=shape+.48*sign(proportion-.5)*pow(abs(proportion-.5),.5);vec4 color_mix=blend_colors(u_color1,u_color2,u_color3,mixer,1.-clamp(u_softness,0.,1.),.01+.01*u_scale);fragColor=vec4(color_mix.rgb,color_mix.a);}\n';
  var VERT = '#version 300 es\nlayout(location = 0) in vec4 a_position;\nvoid main(){gl_Position=a_position;}\n';
  function hexToVec(hex) {
    hex = (hex || '#000000').replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    return [parseInt(hex.slice(0, 2), 16) / 255, parseInt(hex.slice(2, 4), 16) / 255, parseInt(hex.slice(4, 6), 16) / 255, 1];
  }
  function bezierY(x) { // cubic-bezier(.65,0,.88,.77)
    var lo = 0, hi = 1, t = 0;
    for (var k = 0; k < 40; k++) { t = (lo + hi) / 2; var bx = 3 * (1 - t) * (1 - t) * t * .65 + 3 * (1 - t) * t * t * .88 + t * t * t; if (bx < x) lo = t; else hi = t; }
    return 3 * (1 - t) * (1 - t) * t * 0 + 3 * (1 - t) * t * t * .77 + t * t * t;
  }
  function initLiquid(el) {
    var canvas = el.querySelector('canvas');
    var gl = canvas && canvas.getContext('webgl2', { premultipliedAlpha: true });
    if (!gl) return;
    function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; }
    var vs = sh(gl.VERTEX_SHADER, VERT), fs = sh(gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return;
    var prog = gl.createProgram(); gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'a_position'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    function U(n) { return gl.getUniformLocation(prog, n); }
    gl.uniform1f(U('u_scale'), 0);
    gl.uniform1f(U('u_rotation'), -285 * Math.PI / 180);
    gl.uniform4fv(U('u_color1'), hexToVec(el.getAttribute('data-c1')));
    gl.uniform4fv(U('u_color2'), hexToVec(el.getAttribute('data-c2')));
    gl.uniform4fv(U('u_color3'), hexToVec(el.getAttribute('data-c3')));
    gl.uniform1f(U('u_proportion'), 0);
    gl.uniform1f(U('u_softness'), .6);
    gl.uniform1f(U('u_shape'), 0);
    gl.uniform1f(U('u_shapeScale'), .6);
    gl.uniform1f(U('u_distortion'), 6 / 50);
    gl.uniform1f(U('u_swirl'), .26);
    gl.uniform1f(U('u_swirlIterations'), 12);
    var uTime = U('u_time'), uRes = U('u_resolution'), uPr = U('u_pixelRatio');
    var speed = bezierY((parseFloat(el.getAttribute('data-speed')) || 0) / 100) * 5;
    var total = 490 * 8.333333333333334, last = performance.now(), visible = true, raf = null;
    function resize() {
      var dpr = window.devicePixelRatio || 1;
      var w = Math.max(1, Math.round(canvas.clientWidth * dpr)), h = Math.max(1, Math.round(canvas.clientHeight * dpr));
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; gl.viewport(0, 0, w, h); }
      gl.uniform2f(uRes, w, h); gl.uniform1f(uPr, dpr);
    }
    function frame(now) {
      total += (now - last) * speed; last = now;
      gl.uniform1f(uTime, total * .001);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
      raf = visible && speed > 0 ? requestAnimationFrame(frame) : null;
    }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(function () { resize(); if (!raf) frame(performance.now()); }).observe(canvas);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible && !raf) { last = performance.now(); raf = requestAnimationFrame(frame); }
      }).observe(el);
    }
    el.style.background = 'none';
    frame(performance.now());
  }
  document.querySelectorAll('[data-liquid]').forEach(initLiquid);
})();
